export const useLoadScriptOnce = () => {
    const loadScriptOnce = (src, attrs = {}) => {
        if (!process.client) {
            return Promise.resolve();
        }

        // Script déjà présent
        if (document.querySelector(`script[src="${src}"]`)) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = true;

            // Attributs optionnels (type, id, nonce, etc.)
            Object.keys(attrs).forEach((key) => {
                script.setAttribute(key, attrs[key]);
            });

            script.onload = () => resolve();
            script.onerror = () => reject(new Error(`Failed to load ${src}`));

            document.head.appendChild(script);
        });
    };

    return { loadScriptOnce };
}